var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M88.276,145.655c-64.249,0-78.854,69.988-79.448,147.096c-0.024,3.209,1.942,6.098,4.956,7.448 c10.321,4.623,22.833,8.292,36.796,10.676l75.176,0.038c14.05-2.383,26.639-6.067,37.013-10.713c3.014-1.351,4.98-4.239,4.956-7.448 C167.129,215.644,152.525,145.655,88.276,145.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M176.552,366.345v-11.114c0-9.504-5.092-18.279-13.344-22.994l-39.554-22.602 c-5.501-3.144-8.896-8.993-8.896-15.329v-16.237H61.793v16.237c0,6.336-3.395,12.185-8.896,15.329l-39.553,22.602 C5.092,336.952,0,345.727,0,355.231v11.114C0,376.096,7.904,384,17.655,384h141.241C168.648,384,176.552,376.096,176.552,366.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M132.414,216.276v46.798c0,9.302-4.881,17.922-12.857,22.709l-22.197,13.319 c-5.591,3.354-12.576,3.354-18.167,0l-22.197-13.319c-7.977-4.786-12.857-13.406-12.857-22.709v-46.798c0,0,52.966,0,70.621-17.655 L132.414,216.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M163.209,332.237l-25.77-14.726c-4.868,6.908-23.315,31.06-49.163,40.006 c-25.848-8.946-44.295-33.098-49.163-40.006l-25.769,14.726C5.092,336.952,0,345.727,0,355.231v11.114 C0,376.096,7.904,384,17.655,384h141.241c9.751,0,17.655-7.904,17.655-17.655v-11.114 C176.552,345.727,171.459,336.952,163.209,332.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M114.759,278.069H88.276c-4.879,0-8.828-3.953-8.828-8.828c0-4.875,3.948-8.828,8.828-8.828h26.483 c9.732,0,17.655-7.918,17.655-17.655c0-4.875,3.948-8.828,8.828-8.828s8.828,3.953,8.828,8.828 C150.069,262.229,134.232,278.069,114.759,278.069z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707487"
    },
    cx: 88.276,
    cy: 269.241,
    r: 8.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M494.816,315.763l-41.981-15.743c-6.891-2.584-11.456-10.73-11.456-18.089h-70.621 c0,7.359-4.565,15.505-11.456,18.089l-41.981,15.743c-10.336,3.876-17.184,13.758-17.184,24.797v25.785 c0,9.751,7.904,17.655,17.655,17.655h176.552c9.751,0,17.655-7.904,17.655-17.655v-25.785 C512,329.521,505.152,319.639,494.816,315.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M494.816,315.763l-33.955-12.733l-43.489,36.241c-6.548,5.457-16.059,5.457-22.605,0l-43.489-36.241 l-33.955,12.733c-10.336,3.876-17.184,13.758-17.184,24.797v25.785c0,9.751,7.904,17.655,17.655,17.655h176.552 c9.751,0,17.655-7.904,17.655-17.655v-25.785C512,329.521,505.152,319.639,494.816,315.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M465.352,174.487l-5.508,82.624c-0.513,7.701-4.361,14.794-10.535,19.425l-18.522,13.891 c-4.584,3.438-10.159,5.297-15.89,5.297h-17.655c-5.73,0-11.306-1.858-15.89-5.297l-18.522-13.892 c-6.174-4.63-10.022-11.724-10.535-19.425l-5.508-82.624c-1.358-20.38,14.807-37.659,35.232-37.659h48.1 C450.545,136.828,466.71,154.106,465.352,174.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M435.388,269.241h-29.319c-4.879,0-8.828-3.953-8.828-8.828s3.948-8.828,8.828-8.828h29.319 c13.431,0,25.535-11.319,26.422-24.719c0.319-4.862,4.638-8.621,9.397-8.22c4.862,0.323,8.543,4.526,8.224,9.393 C477.913,250.759,458.164,269.241,435.388,269.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D5A50"
    },
    d: "M430.119,136.828h-48.1c-20.426,0-36.591,17.279-35.232,37.658l2.196,32.941 c3.036-0.209,78.753-5.652,115.833-24.909l0.535-8.032C466.71,154.106,450.546,136.828,430.119,136.828z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707487"
    },
    cx: 406.069,
    cy: 260.414,
    r: 8.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M407.388,367.623l-64.643-19.485H169.672l-65.059,19.485c-14.935,4.481-25.164,18.228-25.164,33.822 v35.521c0,9.75,7.905,17.655,17.655,17.655h317.793c9.75,0,17.655-7.905,17.655-17.655v-35.521 C432.552,385.85,422.323,372.104,407.388,367.623z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.172,
    y: 375.172,
    style: {
      fill: "#D7DEED"
    },
    width: 17.655,
    height: 79.448
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D29B6E"
    },
    points: "317.793,286.898 317.793,336.185 256,375.172 194.207,336.185 194.207,286.898 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M194.207,286.898v49.288l19.052,12.021c76.623,8.262,104.166-55.425,104.166-55.425l0.067-5.884 H194.207z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M256,375.172l-63.156-47.367c-4.054-3.041-9.831-2.051-12.641,2.165l-12.479,18.719l38.72,54.207 c2.944,4.121,8.744,4.926,12.697,1.762L256,375.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M256,375.172l63.156-47.367c4.054-3.041,9.831-2.051,12.641,2.165l12.479,18.719l-38.72,54.207 c-2.944,4.121-8.744,4.926-12.697,1.762L256,375.172z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M289.848,316.068l35.43-29.525c6.558-5.464,10.913-13.119,12.262-21.547l20.135-125.839 c6.866-42.908-26.28-81.778-69.733-81.778H224.06c-43.454,0-76.599,38.87-69.734,81.778l20.135,125.839 c1.348,8.428,5.705,16.083,12.262,21.547l35.43,29.525c4.759,3.966,10.759,6.138,16.953,6.138h33.79 C279.09,322.207,285.089,320.035,289.848,316.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D29B6E"
    },
    d: "M237.186,177.401c40.69-5.722,75.887-16.968,100.209-26.297c0.026,0.003-4.981-16.759-4.904-16.748 l-5.87,2.472c0,0-61.793,25.012-132.414,26.483H158.19l16.27,101.686c1.348,8.428,5.705,16.083,12.262,21.547l35.431,29.525 c4.759,3.966,10.758,6.137,16.952,6.137h8.067l-13.126-39.375c-3-9.001-4.53-18.428-4.53-27.915V186.1 C229.517,181.69,232.819,178.015,237.186,177.401z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M131.712,411.37l-41.939-34.829c-6.44,6.466-10.325,15.325-10.325,24.904v35.521 c0,9.75,7.905,17.655,17.655,17.655h44.138v-22.906C141.241,423.854,137.75,416.401,131.712,411.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M432.552,436.966v-35.521c0-9.611-3.907-18.503-10.386-24.973l-41.878,34.899 c-6.038,5.032-9.529,12.484-9.529,20.344v22.906h44.138C424.647,454.621,432.552,446.716,432.552,436.966z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M266.569,295.724c-4.879,0-8.828-3.953-8.828-8.828s3.948-8.828,8.828-8.828 c67.293,0,78.354-35.224,78.793-36.724c1.345-4.638,6.189-7.38,10.854-6.078c4.655,1.298,7.423,6.047,6.182,10.716 C361.853,248.018,348.224,295.724,266.569,295.724z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5B5D6E"
    },
    cx: 266.571,
    cy: 286.897,
    r: 8.828
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M163.84,198.621h-11.363c-4.875,0-8.828,3.953-8.828,8.828v35.31c0,4.875,3.953,8.828,8.828,8.828 h19.839L163.84,198.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M361.931,198.621H348.16l-8.474,52.966h22.246c4.875,0,8.828-3.953,8.828-8.828v-35.31 C370.759,202.573,366.806,198.621,361.931,198.621z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A4146"
    },
    d: "M194.207,163.31c70.621-1.471,132.414-26.483,132.414-26.483l7.745,54.214 c0.621,4.349,4.345,7.58,8.739,7.58h5.056l9.514-59.464c6.865-42.908-26.281-81.778-69.735-81.778H224.06 c-43.454,0-76.599,38.87-69.734,81.778l9.514,59.464h7.256c3.343,0,6.4-1.889,7.895-4.879L194.207,163.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSvgrepoCom);
export default __webpack_public_path__ + "static/media/team-svgrepo-com.3c98230fddf300caf26e604bb4d8eb81.svg";
export { ForwardRef as ReactComponent };